import type { CardStatus } from '../lib/scheduler';

export type PhraseStatus = CardStatus | 'unmet' | 'flagged';

/** One ladder everywhere (Today's can-dos use it too): New, then Settling in, then Solid. */
const LABEL: Record<PhraseStatus, string> = {
  unmet: 'New',
  new: 'Settling in',
  learning: 'Settling in',
  known: 'Solid',
  mastered: 'Solid',
  flagged: 'Flagged',
};

/** A status with a distinct shape per level, so it never relies on colour alone. */
function Shape({ status }: { status: PhraseStatus }) {
  const common = { className: 'status-icon', viewBox: '0 0 14 14', 'aria-hidden': true } as const;
  switch (status) {
    case 'mastered':
    case 'known':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="6" fill="currentColor" />
          <path d="M4 7.2l2 2 4-4.4" stroke="var(--surface)" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'learning':
    case 'new':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M7 1.5a5.5 5.5 0 0 1 0 11z" fill="currentColor" />
        </svg>
      );
    case 'flagged':
      return (
        <svg {...common}>
          <path d="M3 13V2h7l-1.5 3L10 8H3" fill="currentColor" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
        </svg>
      );
  }
}

export function StatusShape({ status }: { status: PhraseStatus }) {
  return <Shape status={status} />;
}

export function Status({ status }: { status: PhraseStatus }) {
  return (
    <span className="status" data-status={status}>
      <Shape status={status} />
      {LABEL[status]}
    </span>
  );
}
